export const formats = Object.freeze({
    backendDateFormat: 'YYYY-MM-DD',
    frontendDateFormat: 'DD-MM-YYYY',
    backendDateTimeFormat: 'YYYY-MM-DD hh:mm:ssZ',
    frontendDateTimeFormat: 'DD-MM-YYYY hh:mm:ss a',
})